import {ChangeDetectionStrategy, Component} from '@angular/core'
import {Monologic} from '../../../../../craft/dialog/monologic.interface'

@Component({
  selector: 'bgo-information-dialog',
  templateUrl: './information-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InformationDialogComponent implements Monologic<Props> {
  props!: Props

  setData(data: Props): void {
    this.props = data
  }
}

interface Props {
  title: string
  info: string
}
